import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { useStore } from '../../store/store';
import { getPrimaryDark } from '../../constants/constants';
import { marginOnPageButton } from '../../constants/gridConfig';
import avatarMan from './avatar-man.png';
import avatarWoman from './avatar-woman.png';

// L'API ne renvoie pas toujours de photo (utilisateur jamais passé par un
// flux qui en assigne une côté back) : on retombe sur l'avatar par défaut
// correspondant au genre plutôt que de laisser une icône générique.
const genderAvatars = {
  'M.': avatarMan,
  'Mme.': avatarWoman,
};

const selector = () => (state) => ({
  user: state?.user,
  isTemplate: state?.currentDocument?.type === 'template',
});

export const UserInfosComponent = () => {
  const { user, isTemplate } = useStore(selector());
  // Avatars par défaut : silhouette blanche sur fond transparent, invisible sur la barre blanche. On la pose
  // sur la couleur du logo du mode (navy en proposition, violet en modèle).
  const isDefaultAvatar = !user.photo;

  return (
    <Avatar
      shape='square'
      style={{
        height: '32px',
        width: '32px',
        // Carré aux coins de 5 px, comme les boutons de la barre du haut (navbarButtonStyle).
        borderRadius: 5,
        marginRight: marginOnPageButton,
        ...(isDefaultAvatar ? { backgroundColor: getPrimaryDark(isTemplate) } : {}),
      }}
      size='default'
      icon={<UserOutlined />}
      src={user.photo || genderAvatars[user.gender]}
    />
  );
};
